import api from "../Utils/axios";

export const getPayoutRequests = (page = 1, limit = 50, search = "", status = "pending") => {
  return api.post("/driver-payout/admin/payout-requests", {
    page,
    limit,
    search,
    status,
  });
};

export const getPayoutHistory = (page = 1, limit = 50, search = "") => {
  return api.post("/driver-payout/admin/payout-requests", {
    page,
    limit,
    search,
    status: "approved,rejected",
  });
};

export const getPendingDrivers = (page = 1, limit = 50, search = "") => {
  return api.post("/driver-payout/admin/pending-drivers", {
    page,
    limit,
    search,
  });
};

export const handlePayoutRequests = (action, requestIds, adminNote = "") => {
  return api.post("/driver-payout/admin/payout-requests/handle", {
    action,
    requestIds,
    adminNote,
  });
};

export const getAutoPayoutStatus = () => {
  return api.get("/driver-payout/admin/auto-payout-status");
};

export const processBatchPayout = (driverIds, adminNote = "Admin batch payout") => {
  return api.post("/driver-payout/admin/batch-payout", {
    driverIds,
    adminNote,
  });
};
